export const sanitizeMobileNumberInput = (
  value: string | null | undefined
): string => {
  if (value == null || value === '') {
    return '';
  }
  return value.replace(/\D/g, '');
};

export const applyMobileNumberToIonInput = (
  ionInputEl: HTMLIonInputElement,
  sanitized: string
): void => {
  if ((ionInputEl.value ?? '') !== sanitized) {
    ionInputEl.value = sanitized;
  }
};

export const handleIonMobileNumberInput = (
  event: CustomEvent,
  onSanitized: (sanitized: string) => void
): void => {
  const sanitized = sanitizeMobileNumberInput(event.detail.value);
  applyMobileNumberToIonInput(event.target as HTMLIonInputElement, sanitized);
  onSanitized(sanitized);
};
